import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _toConsumableArray from "@babel/runtime-corejs2/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as PropTypes from 'prop-types';
import omit from 'lodash/omit';
import { getContainer } from '../_utils/Dom';
import { ToastEntity } from './ToastEntity';

var random = function random() {
  return Math.random().toString(36).substring(2, 8);
};
/**
 * 根据 placement 生成 Toast 容器的样式
 * @param placement string
 * @param position object
 * @return 容器样式
 */


var generateStyle = function generateStyle(placement, position) {
  var zIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1200;

  // 分割小驼峰获取位置信息
  var _placement$replace$to = placement.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase().split('-'),
      _placement$replace$to2 = _slicedToArray(_placement$replace$to, 2),
      first = _placement$replace$to2[0],
      second = _placement$replace$to2[1];

  var style = {};

  if (first === 'center') {
    style = {
      top: '50%',
      left: '50%',
      transform: 'translate3d(-50%, -50%, 0)'
    };
  } else {
    var _ref, _ref2;

    style = second === 'center' ? (_ref = {}, _defineProperty(_ref, first, position[first] || '60px'), _defineProperty(_ref, "left", '50%'), _defineProperty(_ref, "transform", 'translate3d(-50%, 0, 0)'), _ref) : (_ref2 = {}, _defineProperty(_ref2, first, position[first] || '60px'), _defineProperty(_ref2, second, position[second] || '60px'), _ref2);
  }

  return _Object$assign({
    position: 'fixed',
    zIndex: zIndex
  }, style);
};
/**
 * Roo-theme 内样式无效
 * 覆盖 Toast 默认样式
 */


var toastStyle = {
  display: 'block',
  position: 'relative',
  transform: 'none',
  left: 'auto',
  top: 'auto',
  marginBottom: '20px'
};
/**
 * Toast 容器组件
 */

var ToastWrap = /*#__PURE__*/function (_React$Component) {
  _inherits(ToastWrap, _React$Component);

  var _super = _createSuper(ToastWrap);

  function ToastWrap() {
    var _this;

    _classCallCheck(this, ToastWrap);

    _this = _super.apply(this, arguments);
    _this.state = {
      configs: [_this.props.initConfig]
    };

    _this.add = function (config) {
      _this.setState(function (state) {
        return {
          configs: [].concat(_toConsumableArray(state.configs), [config])
        };
      });
    };

    _this.remove = function (key) {
      var curConfig = _this.state.configs.filter(function (config) {
        return config.key === key;
      })[0];

      _this.setState(function (state) {
        return {
          configs: state.configs.filter(function (config) {
            return config.key !== key;
          })
        };
      }, function () {
        /* eslint-disable-next-line */
        curConfig.onClose && curConfig.onClose();
      });
    };

    return _this;
  }

  _createClass(ToastWrap, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var configs = this.state.configs;
      var position = this.props.position;
      var _this$props$initConfi = this.props.initConfig,
          top = _this$props$initConfi.top,
          bottom = _this$props$initConfi.bottom,
          left = _this$props$initConfi.left,
          right = _this$props$initConfi.right,
          zIndex = _this$props$initConfi.zIndex;
      var wrapStyle = generateStyle(position, {
        top: top,
        left: left,
        right: right,
        bottom: bottom
      }, zIndex);
      return /*#__PURE__*/React.createElement("div", {
        style: wrapStyle
      }, configs.map(function (config) {
        var key = config.key,
            style = config.style;
        var rest = omit(config, ['top', 'left', 'right', 'bottom', 'style', 'key', 'popupContainer']);

        var styles = _Object$assign({}, toastStyle, style);

        return /*#__PURE__*/React.createElement(ToastEntity, _Object$assign({}, rest, {
          key: key,
          onClose: function onClose() {
            _this2.remove(key);
          },
          style: styles
        }));
      }));
    }
  }]);

  return ToastWrap;
}(React.Component);

ToastWrap.propTypes = {
  initConfig: PropTypes.object.isRequired,
  position: PropTypes.oneOf(['center', 'topLeft', 'topCenter', 'topRight', 'bottomLeft', 'bottomRight', 'bottomCenter'])
};
ToastWrap.defaultProps = {
  position: 'topRight'
}; // const IS_REACT_16 = !!ReactDOM.createPortal;

var toastWrapRef = {};
var defaultPosition = ['center', 'topLeft', 'topCenter', 'topRight', 'bottomLeft', 'bottomRight', 'bottomCenter'];
/**
 * 缓存不同 position 的容器 DOM
 */

var positionWrapDOM = {};
/**
 * 缓存每个 position 上的 toast 实例
 */

var keyToPosition = {};
var Toast = {
  open: open,
  close: _close,
  destroy: destroy
};
var statusToast = ['loading', 'success', 'warning', 'fail', 'info'];
statusToast.forEach(function (item) {
  Toast[item] = function (props) {
    return open(_Object$assign({
      status: item
    }, props));
  };
});
/**
 * 创建一个 Toast
 * @param props
 */

function open(props) {
  var position = props.position,
      popupContainer = props.popupContainer; // @ts-ignore

  var innerPosition = defaultPosition.indexOf(position) > -1 ? position : 'topRight';
  props.key = props.key ? props.key : random();
  keyToPosition[props.key] = innerPosition;

  if (!positionWrapDOM[innerPosition]) {
    positionWrapDOM[innerPosition] = document.createElement('div');
    positionWrapDOM[innerPosition].setAttribute('data-position', innerPosition);
    getContainer(popupContainer).appendChild(positionWrapDOM[innerPosition]);
    render(positionWrapDOM[innerPosition]);
  } else {
    toastWrapRef[innerPosition].add(props);
  }

  function toastRef(toast) {
    toastWrapRef[innerPosition] = toast;
  }

  function render(DOM) {
    ReactDOM.render( /*#__PURE__*/React.createElement(ToastWrap, {
      ref: toastRef,
      position: innerPosition,
      initConfig: props
    }), DOM);
  }

  return {
    close: function close() {
      return _close(props.key);
    }
  };
}
/**
 * 关闭一个 Toast
 * @param key 用户自定义的 key，或者随机生成的。
 */


function _close(key) {
  var position = keyToPosition[key];

  if (position) {
    toastWrapRef[position].remove(key);
  }
}
/**
 * 销毁所有位置的 Toast
 */


function destroy() {
  _Object$keys(positionWrapDOM).map(function (key) {
    if (positionWrapDOM[key]) {
      ReactDOM.unmountComponentAtNode(positionWrapDOM[key]);
      positionWrapDOM[key].parentNode.removeChild(positionWrapDOM[key]); // @ts-ignore

      positionWrapDOM[key] = null;
      return true;
    }

    return false;
  });
}

export default Toast;